module.exports = __webpack_public_path__ + "img/right_suc.363ba129.png";